"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderListingContainer = void 0;
var react_1 = __importStar(require("react"));
var web_1 = require("../../../Button/web");
var web_2 = require("../../../Tabs/web");
var HeaderListingContainer_style_1 = require("./HeaderListingContainer.style");
function HeaderListingContainer(props) {
    var onClickHeaderBtn = props.onClickHeaderBtn, tabs = props.tabs, tabsRef = props.tabsRef, navActions = props.navActions, scrollListingRef = props.scrollListingRef;
    var TitleContainerComponent = react_1.useMemo(function () { return TitleContainer; }, [props.TitleContainerComponent]);
    return (react_1.default.createElement(HeaderListingContainer_style_1.HeaderListingContainerStyle, null,
        react_1.default.createElement("div", { className: "page-listing-title" },
            react_1.default.createElement("div", { className: "d-flex" },
                react_1.default.createElement("div", { className: "flex-fill align-self-center" },
                    react_1.default.createElement(TitleContainerComponent, __assign({}, props))),
                react_1.default.createElement("div", { className: "text-right align-self-center" }, onClickHeaderBtn && react_1.default.createElement(web_1.Button, { onClick: onClickHeaderBtn }, "Adicionar")))),
        tabs && (react_1.default.createElement("div", { className: "header-listing-tabs-container" },
            react_1.default.createElement(web_2.Tabs, __assign({}, tabs, { ref: tabsRef }))))));
}
exports.HeaderListingContainer = HeaderListingContainer;
function TitleContainer(props) {
    var title = props.title, _a = props.textResourceSingular, textResourceSingular = _a === void 0 ? 'resultado' : _a, _b = props.textResourcePlural, textResourcePlural = _b === void 0 ? 'resultados' : _b, viewList = props.viewList;
    var resourcesTotal = viewList.resourcesTotal, searching = viewList.searching, starting = viewList.starting;
    return (react_1.default.createElement("h1", null,
        react_1.default.createElement("span", { className: ((searching || starting) && 'text-skeleton') + " text-non-skeleton" }, title ||
            resourcesTotal + " " + (resourcesTotal === 1 ? textResourceSingular : textResourcePlural) + " " + (resourcesTotal === 1 ? 'encontrado' : 'encontrados'))));
}
//# sourceMappingURL=HeaderListingContainer.js.map